import cn from 'classnames'
import { useMemo } from 'react'

import { Translation } from 'cng-common/features/translations/components/translation'
import { Button } from 'core-components/library/button'

import tr from '../../translations'

import styles from './FinSobValidationPopupHeader.module.scss'

interface IProps {
  inputCount: number
  inputIndex: number
  onNextInput: () => void
  onPrevInput: () => void
}

export const FinSobValidationPopupHeader = ({
  inputCount,
  inputIndex,
  onNextInput,
  onPrevInput,
}: IProps) => {
  /** -------------------- Variables ----------------------- */

  const isShowInputNavigation = useMemo(() => {
    return inputCount > 1
  }, [inputCount])

  /** -------------------- Render ----------------------- */

  return (
    <header className={styles.root}>
      <div className={styles.navigation}>
        {isShowInputNavigation && (
          <Button
            className={cn(styles.navButton, styles.prev)}
            disabled={!isShowInputNavigation}
            color="grey"
            iconButton={'kbase kbase-omni-chevron-left'}
            onClick={onPrevInput}
          />
        )}
        <div className={styles.title}>
          <Translation
            span
            text={`${isShowInputNavigation ? tr.dialogNavHeader : tr.dialogHeader}`}
            replaceParams={[
              { key: '{inputIndex}', value: ((inputIndex ?? 0) + 1).toString() },
              { key: '{inputCount}', value: (inputCount ?? 0).toString() },
            ]}
          />
        </div>
        {isShowInputNavigation && (
          <Button
            className={cn(styles.navButton, styles.next)}
            disabled={!isShowInputNavigation}
            color="grey"
            iconButton={'kbase kbase-omni-chevron-right'}
            onClick={onNextInput}
          />
        )}
      </div>
    </header>
  )
}
